import './hotspot-title.sass'
export { default } from './TitleHotspot'
